import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isSubPage = location.pathname !== '/';

  const linkClass = isSubPage
    ? 'text-black hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap font-medium'
    : 'text-white hover:text-gray-200 transition-colors cursor-pointer whitespace-nowrap font-medium drop-shadow-lg';

  const headerBg = isSubPage ? 'bg-white shadow-sm' : 'bg-transparent';

  return (
    <header className={`absolute top-0 left-0 right-0 z-50 ${headerBg}`}>
      <div className="container mx-auto px-6 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <a href="/">
              <img 
                src="https://static.readdy.ai/image/2e9ecc346a2ca29966c0e167990e2bed/ac17c2410a5c5bdc3182efc3680fe414.png" 
                alt="handgepackt Logo" 
                className={`h-28 w-auto drop-shadow-lg ${isSubPage ? 'invert' : ''}`}
              />
            </a>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <a href={isSubPage ? '/#services' : '#services'} className={linkClass}>
              Leistungen
            </a>
            <a href={isSubPage ? '/#price-calculator' : '#price-calculator'} className={linkClass}>
              Ihr Preis
            </a>
            <a href={isSubPage ? '/#about' : '#about'} className={linkClass}>
              Über uns
            </a>
            <a href={isSubPage ? '/#process' : '#process'} className={linkClass}>
              Unser Prozess
            </a>
            <a href={isSubPage ? '/#contact' : '#contact'} className={linkClass}>
              Kontakt
            </a>
            <a
              href="/test-buchen"
              className={`px-6 py-3 rounded-lg transition-all cursor-pointer whitespace-nowrap font-semibold shadow-lg ${
                isSubPage
                  ? 'bg-black text-white hover:bg-gray-800'
                  : 'bg-white/90 backdrop-blur-sm text-black hover:bg-white'
              }`}
            >
              Test buchen
            </a>
          </nav>

          <button 
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer rounded-lg ${
              isSubPage ? 'bg-gray-100' : 'bg-black/20 backdrop-blur-sm'
            }`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-menu-line text-xl drop-shadow-lg ${isSubPage ? 'text-black' : 'text-white'}`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className={`md:hidden mt-6 pb-4 rounded-lg p-4 ${isSubPage ? 'bg-white border border-gray-200 shadow-lg' : 'bg-black/80 backdrop-blur-sm'}`}>
            <nav className="flex flex-col space-y-4">
              <a href={isSubPage ? '/#services' : '#services'} className={isSubPage ? 'text-black hover:text-gray-600 transition-colors cursor-pointer font-medium' : 'text-white hover:text-gray-200 transition-colors cursor-pointer font-medium'}>
                Leistungen
              </a>
              <a href={isSubPage ? '/#price-calculator' : '#price-calculator'} className={isSubPage ? 'text-black hover:text-gray-600 transition-colors cursor-pointer font-medium' : 'text-white hover:text-gray-200 transition-colors cursor-pointer font-medium'}>
                Ihr Preis
              </a>
              <a href={isSubPage ? '/#about' : '#about'} className={isSubPage ? 'text-black hover:text-gray-600 transition-colors cursor-pointer font-medium' : 'text-white hover:text-gray-200 transition-colors cursor-pointer font-medium'}>
                Über uns
              </a>
              <a href={isSubPage ? '/#process' : '#process'} className={isSubPage ? 'text-black hover:text-gray-600 transition-colors cursor-pointer font-medium' : 'text-white hover:text-gray-200 transition-colors cursor-pointer font-medium'}>
                Unser Prozess
              </a>
              <a href={isSubPage ? '/#contact' : '#contact'} className={isSubPage ? 'text-black hover:text-gray-600 transition-colors cursor-pointer font-medium' : 'text-white hover:text-gray-200 transition-colors cursor-pointer font-medium'}>
                Kontakt
              </a>
              <a
                href="/test-buchen"
                className={`px-6 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap w-fit font-semibold ${
                  isSubPage ? 'bg-black text-white hover:bg-gray-800' : 'bg-white text-black hover:bg-gray-100'
                }`}
              >
                Test buchen
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
